import i18n from "../i18n";

/**
 * 处理API错误并返回本地化的错误消息
 * @param payload 错误载荷对象
 * @param errorMessage 默认错误消息
 * @returns 本地化的错误消息
 */
export const getLocalizedErrorMessage = (
  payload: any,
  errorMessage?: string
): string => {
  let localizedMessage = errorMessage || payload?.message;

  // 检查是否有错误代码，并尝试获取对应的翻译
  if (payload?.code) {
    const errorCode = payload.code;
    const translationKey = `errCode${errorCode}`;

    // 检查是否有对应的翻译键
    if (i18n.exists(translationKey)) {
      localizedMessage = i18n.t(translationKey);
    }
  }

  // 如果没有错误消息，使用通用错误消息
  if (!localizedMessage) {
    localizedMessage = i18n.t("errGeneric");
  }

  return localizedMessage;
};

/**
 * 检查是否需要处理token过期
 * @param errorCode 错误代码
 * @returns 是否已处理token过期
 */
export const handleTokenExpiration = (errorCode?: number): boolean => {
  if (errorCode === 505) {
    localStorage.removeItem("driverInfo");
    localStorage.removeItem("dtoken");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");

    // 根据用户类型重定向到相应的登录页面
    if (localStorage.getItem("isDriver") === "true") {
      window.location.href = "/driver-login";
    } else {
      window.location.href = "/login";
    }
    return true;
  }
  return false;
};
